<template>
<div id="">
  <v-container fluid class="pt-0 ">
    <v-dialog v-model="show_register" :width="600">
      <register @registered="load" @close="show_register=false"></register>
    </v-dialog>
    <v-dialog v-model="show_edit" :width="600" persistent>
      <edit :account="edit_account" @edited="load" @close="show_edit=false"></edit>
    </v-dialog>
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">
          <v-card-title class="secondary white--text">
            Business Accounts
            <v-spacer></v-spacer>
            <v-btn fab small color="green" class="mr-4" dark @click="show_register=true">
              <v-icon>fa-plus</v-icon>
            </v-btn>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-container class=" white--text">
            <v-row align="center">

              <v-col cols="12" md="4" lg="3" xl="2">
                <v-text-field v-model="search" append-icon="fa-search" dark label="Search" outlined hide-details clearable></v-text-field>
              </v-col>

            </v-row>
            <v-data-table :loading="loading" :headers="headers" :items="accountsList" :search="search">
              <template v-slot:item.name="{ item }">
              {{item.name}}
                </template>

              <template v-slot:item.actions="{ item }">
                  <v-btn icon small color="blue" @click="editAccount(item)"><v-icon small>fa fa-edit</v-icon></v-btn>
                    </template>


            </v-data-table>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import headersSimple from "./headers_simple.json"
import register from "./register"
import edit from "./edit"

export default {
  name: "",
  components: {
    register,
    edit
  },
  data: () => ({
    show_register: false,
    show_edit: false,
    edit_account: null,
    search: '',
    loading: false,
    accounts: [],
  }),
  computed: {
    headers() {
      return headersSimple
    },
    accountsList() {
      return this.accounts.filter(a => {
        return a.type === 'business'
      }).map(function(a) {
        return a;
      }.bind(this))
    }
  },
  methods: {
    editAccount(account) {
      this.edit_account = { ...account
      };
      this.show_edit = true;
    },
    async load() {
      this.loading = true
      await Promise.all([this.loadAccounts()])
      this.loading = false
    },
    async loadAccounts() {
      this.accounts = await this.$api(`/account/admin/accounts`)
    }
  },
  created() {
    this.load()
    if (this.$route.query.search) {
      this.search = this.$route.query.search
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
